import { createPool } from "mysql2/promise";

export const dbConfig = {
  host: process.env.DB_HOST,
  user: process.env.DB_USER,
  password: process.env.DB_PASSWORD,
  database: process.env.DB_NAME,
  port: process.env.DB_PORT,
};

// Création d'un pool MySQL unique pour toute l'application
const pool = createPool(dbConfig);

/**
 * Renvoie une PromiseConnection issue du pool,
 * avec la méthode .release() disponible pour remettre la connexion dans le pool.
 */
export async function getConnection() {
  return await pool.getConnection();
}
